import React from "react";
import { Routes, Route } from "react-router-dom";
import HousePost from "../../pages/RealEstateAgent/HousePost";
import RealEstateLayout from "../../pages/RealEstateAgent/RealEstateLayout";
import PropertyPost from "../../pages/RealEstateAgent/PropertyPost";
import CustomerQueryPage from "../../pages/RealEstateAgent/CustomerQueryPage";
import Profile from "../../pages/RealEstateAgent/Profile";
import AgentSignup from "../../pages/RealEstateAgent/AgentSignup";
import AgentLogin from "../../pages/RealEstateAgent/AgentLogin";
import NotificationPage from "../../pages/RealEstateAgent/NotificationPage";
import ForgotPassword from "../../pages/RealEstateAgent/ForgotPassword";

import Transaction from "../../pages/RealEstateAgent/Transaction";

const AgentRoutes = () => {
    return (
        <Routes>
            <Route path="/housingpost" element={<HousePost />} />
            <Route path="/housingpost/edit/:id" element={<HousePost />} />
            <Route path="/propertypost" element={<PropertyPost />} />
            <Route path="/propertypost/edit/:id" element={<PropertyPost />} />
            <Route path="/real-estate" element={<RealEstateLayout />} />
            <Route path="/customerquery" element={<CustomerQueryPage />} />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/notification" element={<NotificationPage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/login" element={<AgentLogin />} />
            <Route path="/signup" element={<AgentSignup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
    );
};

export default AgentRoutes;
